import React from 'react';
import Header from './header';
import ListaProcessos from './ListaProcessos';
import { connect } from 'react-redux';
import { logout, mudarUser,  mudarLoadingHome,mudarFaculdade } from '../actions/AppActions';
import { URL } from '../variables';
// import io from 'socket.io-client';
import { BrowserRouter, Route, Switch, Redirect, Link } from "react-router-dom";
import Sala from './Sala';
import Redacoes from './Redacoes';
import RedacaoCorrigida from './RedacaoCorrigida';
import CorrecaoDissertativa from './CorrecaoDissertativa';
import CorrecaoDissertativaCorrigida from './CorrecaoDissertativaCorrigida';
import EditProfile from './EditProfile/EditProfile';
import { languages, getSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

const OtherRoute = ({ component: Component, path_name, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <Redirect to={{ pathname: path_name, state: { from: props.location } }} />
    }
  />
);
class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // redirect:'/not_processo',
      selectedLanguage: getSelectedLanguage()
    }
    this.videoRef = React.createRef();
    this.imageRef = React.createRef();

    // this.videoRef=null;
  }
  logout() {
    localStorage.removeItem('token');
    // this.setState({redirect:true,path:'/'});
    this.props.logout();
  }

  componentDidMount() {
    this.props.mudarLoadingHome(true);
    this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
    window.addEventListener('correcao_language_change', this.languageListener);

    this.get_user();

  }

  componentWillUnmount() {
    if (this.languageListener) {
      window.removeEventListener('correcao_language_change', this.languageListener);
    }
  }

  async get_user() {

    fetch(`${URL}api/corretor/get_user/`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          // this.props.mudarLoadingHome(false);
          setTimeout(()=>{
            this.get_user();
          },5000);
        }
        else {
          this.props.mudarUser(resp.user);
          this.props.mudarFaculdade(resp.faculdade);
          this.props.mudarLoadingHome(false);

        }




      } catch (err) {
        console.log(err);
        // this.props.mudarLoadingHome(false);
        setTimeout(()=>{
          this.get_user();
        },5000);

      }

    })
      .catch((err) => {
        console.log(err);
        // this.props.mudarLoadingHome(false);
        setTimeout(()=>{
          this.get_user();
        },5000);
      });
  }

  componentDidUpdate() {
    if (this.props.stream != null && this.videoRef.current != null) {
      this.videoRef.current.srcObject = this.props.stream
    }
  }

  getBreadcrumbItems() {
    let baseUrl = this.props.match.url;
    let pathname = this.props.location.pathname;
    let path = pathname.replace(baseUrl, '').replace(/^\/+/, '');
    let section = path.split('/')[0];
    let homeUrl = baseUrl || '/';
    let items = [
      { label: this.getTexts().breadcrumb_home, to: homeUrl },
      { label: this.props.faculdade.name, to: homeUrl }
    ];

    if (section === '') {
      items.push({ label: this.getTexts().breadcrumb_processes });
    }
    else if (section === 'list') {
      items.push({ label: this.getTexts().breadcrumb_processes, to: homeUrl });
      items.push({ label: this.getTexts().breadcrumb_modules });
    }
    else if (section === 'redacoes') {
      items.push({ label: this.getTexts().breadcrumb_processes, to: homeUrl });
      items.push({ label: this.getTexts().breadcrumb_essays });
    }
    else if (section === 'correcoes') {
      items.push({ label: this.getTexts().breadcrumb_processes, to: homeUrl });
      items.push({ label: this.getTexts().breadcrumb_corrected_essay });
    }
    else if (section === 'dissertativas') {
      items.push({ label: this.getTexts().breadcrumb_processes, to: homeUrl });
      items.push({ label: this.getTexts().breadcrumb_discursive });
    }
    else if (section === 'dissertativas_corrigidas') {
      items.push({ label: this.getTexts().breadcrumb_processes, to: homeUrl });
      items.push({ label: this.getTexts().breadcrumb_discursive_corrected });
    }
    else if (section === 'edit_profile') {
      items.push({ label: this.getTexts().breadcrumb_profile });
    }

    return items;
  }

  getTexts() {
    return languages[this.state.selectedLanguage] || languages.Pt;
  }

  renderBreadcrumb() {
    let items = this.getBreadcrumbItems();
    return (
      <nav className="correcao-breadcrumb" aria-label="breadcrumb">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {item.to && index < items.length - 1 ? <Link to={item.to}>{item.label}</Link> : (index === items.length - 1 ? <strong>{item.label}</strong> : <span>{item.label}</span>)}
            {index < items.length - 1 && <i className="mdi mdi-chevron-right"></i>}
          </React.Fragment>
        ))}
      </nav>
    );
  }

  render() {
    let t = this.getTexts();
    return (
      <div>
        {/* {this.state.redirect == true && <Redirect to={this.state.path} />} */}
        <img ref={this.imageRef} src="/imgs/eu.jpeg" hidden />
        <div id="wrapper">
          <Header />
          {this.props.loading_home == false && <div className="correcao-system-shell">
            <div className="content-page correcao-content-page" style={{ marginLeft: 0 }}>
              <div className="content">
                

                <div className="container-fluid correcao-container">
                  <div className="page-title-box correcao-page-title-box">
                    <div className="row align-items-center">
                      <div className="col-sm-12">
                        <span>{t.corrector_area}</span>
                        <h2 style={{ color: 'black' }}>{this.props.faculdade.name}</h2>
                        {this.renderBreadcrumb()}
                      </div>
                    </div>
                  </div>
                  {/* {this.props.processo != null &&
                   } */}
                  <Switch>
                    
                    <Route exact path={`${this.props.match.url}`} render={(props2) => <ListaProcessos {...props2} t={t} />} />
                    <Route exact path={`${this.props.match.url}list/:id`} render={(props2) => { return (<Sala {...props2} t={t} />) }} />
                    <Route exact path={`${this.props.match.url}redacoes/:id`} render={(props2) => { return (<Redacoes {...props2} t={t} />) }} />
                    <Route exact path={`${this.props.match.url}correcoes/:id/:correcao_id`} render={(props2) => { return (<RedacaoCorrigida {...props2} t={t} />) }} />
                    <Route exact path={`${this.props.match.url}dissertativas/:processo_id/:id`} render={(props2) => { return (<CorrecaoDissertativa {...props2} t={t} />) }} />
                    <Route exact path={`${this.props.match.url}dissertativas_corrigidas/:processo_id/:id`} render={(props2) => { return (<CorrecaoDissertativaCorrigida {...props2} t={t} />) }} />
                    <Route exact path={`${this.props.match.url}edit_profile`} render={(props2) => <EditProfile {...props2} t={t} />} />



                    <OtherRoute path="*" path_name='/' />

                  </Switch>
                  {/* { this.props.children } */}
                  {/* {this.props.processo == null &&
                    <NotProcesso />} */}
                </div>
              </div>
            </div>
          </div>}
          {this.props.loading_home == true && <div className="correcao-loading-screen">
            <Loader title={t.loading_data} description={t.loading_hint} />
          </div>}

        </div>
        <div className="d-none correcao-mobile-block" style={{ height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
          <div>

            <p style={{ textAlign: 'center', fontSize: '1.2rem' }}>Deslogue e acesse pelo computador para poder visualizar nosso conteúdo
          </p>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <a className="btn btn-success btn-lg" onClick={this.logout.bind(this)} style={{ width: '80%', color: 'white' }}><i
                className="mdi mdi-power " style={{ color: 'white' }}></i> Sair</a>
            </div>
          </div>

        </div>
      </div >

    );
  }


}

const mapsStateToProps = (state) => (
  {
    faculdade: state.AppReducer.faculdade,
    token: state.AppReducer.token,
    loading_home: state.AppReducer.loading_home,
    stream: state.AppReducer.stream,
    processo: state.AppReducer.processo,
  }
);

export default connect(mapsStateToProps, { logout, mudarUser, mudarLoadingHome,mudarFaculdade })(Home);
